import React, { useMemo, useState } from "react";
import { IonSelect, IonSelectOption } from "@ionic/react";
import "./InputTypes.css";
type componentProps = {
  question: string;
  answer?: any;
  question_id: number;
  options: string;
  questionno?: number;
  requiredmessage?: boolean;
  allowHtmlQuestion?: any;
  placeholder?: any;
};
const InputTypeCheckbox: React.FC<componentProps> = (Props) => {
  const {
    question,
    answer,
    question_id,
    options,
    questionno,
    requiredmessage,
    allowHtmlQuestion,
    placeholder
  } = Props;

  // Prepare options list and determine if we should use multi-select UI
  const optionList = useMemo(() => (options ? options.split("||") : []), [options]);
  const isMultiOption = useMemo(() => (options ? options.includes("||") : false), [options]);

  // Normalize initial answer -> selected values array
  const initialSelected = useMemo<string[]>(() => {
    if (Array.isArray(answer)) return answer as string[];
    if (answer && typeof answer === "object") {
      // Convert map of { option: boolean } to [option]
      return Object.keys(answer).filter((k) => !!answer[k]);
    }
    return [];
  }, [answer]);

  const [selectedValues, setSelectedValues] = useState<string[]>(initialSelected);

  const toggleCheckbox = (value: string) => {
    setSelectedValues((prev) =>
      prev.includes(value) ? prev.filter((v) => v !== value) : [...prev, value]
    );
  };

  return (
    <div className="take-test-question take-test-question__checkbox">
      <div className="take-test-question__label">
        {/* {questionno && <>{questionno}. </>} */}
        {allowHtmlQuestion ? (
          <span
            dangerouslySetInnerHTML={{
              __html: question,
            }}
          ></span>
        ) : (
          <>{question}</>
        )}
      </div>
      {isMultiOption ? (
        <>
          <IonSelect
            mode="ios"
            multiple={true}
            placeholder={placeholder || "--Select--"}
            className={
              requiredmessage == true
                ? "form-input-styles-error"
                : "form-group__input-styles"
            }
            value={selectedValues}
            // Keep the FormData shape identical by not naming the IonSelect.
            // We mirror selections into hidden checkboxes below.
            onIonChange={(e: any) => setSelectedValues(e.detail.value || [])}
          >
            {optionList.map((data: any, index: number) => (
              <IonSelectOption key={index} value={data}>
                {data}
              </IonSelectOption>
            ))}
          </IonSelect>

          {/* Hidden checkboxes to mirror the IonSelect selections so submit logic remains unchanged */}
          {optionList.map((data: any, index: number) => (
            <input
              key={`hidden_${index}`}
              type="checkbox"
              name={`checkbox_${index}-answer_${question_id}`}
              value={data}
              checked={selectedValues.includes(data)}
              readOnly
              style={{ display: "none" }}
            />
          ))}
          {/* Also include the placeholder hidden input used by existing submit logic */}
          <input type="hidden" name={`checkbox_20-answer_${question_id}`} />
        </>
      ) : (
        <>
          {optionList.map((data: any, index: number) => (
            <div key={index} className="take-test-question__checkbox__container">
              <input
                type="checkbox"
                slot="start"
                name={`checkbox_${index}-answer_${question_id}`}
                value={data}
                className="input-type__checkbox"
                checked={selectedValues.includes(data)}
                onChange={() => toggleCheckbox(data)}
              />
              <span>{data}</span>
            </div>
          ))}
          <input type="hidden" name={`checkbox_20-answer_${question_id}`} />
        </>
      )}
      {requiredmessage === true && (
        <div className="error-message">This field is required.</div>
      )}
    </div>
  );
};

export default InputTypeCheckbox;
